import { Adjustment } from './adjustment';

export class Repo extends Adjustment {
  repoByInpress?: boolean;
  store?: boolean;

  constructor() {
    super();
    this.type = 'Repo';
    this.repoByInpress = true;
    this.handleByAtelier = false;
  }
}
